import cn from 'clsx'

import BlockArrow from '../../images/blockArrow'

import s from './Quote.module.sass'

function Quote({ project }: any) {
    const { quote } = project

    if (!quote) return null

    return (
        <section className={s.Quote}>
            <div className={cn(s.Cont, 'container')}>
                <div className={s.Icons}>
                    {BlockArrow}
                    {BlockArrow}
                </div>
                <div className={s.Main}>
                    {quote && (
                        <h3
                            dangerouslySetInnerHTML={{
                                __html: quote,
                            }}
                        />
                    )}
                </div>
            </div>
        </section>
    )
}

export default Quote
